
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/next/events/infra-event",
      function () {
        return require("private-next-pages/next/events/infra-event.tsx");
      }
    ]);
  